import {
  createBrowserRouter,
  RouterProvider
} from "react-router";
import PageTemplate from "./components/PageTemplate";
import Home from "./pages/Home";
import { rootContext } from "./contexts/rootContext";
import { useMediaQuery } from "@mui/material";

function App() {
  const isScreenTooSmall = useMediaQuery('(max-width:1060px)');
  const isScreenWayTooSmall = useMediaQuery('(max-width:700px)');

  const router = createBrowserRouter([
    {
      path: "/",
      element: (<PageTemplate>
          <Home />
        </PageTemplate>),
    }
  ]);

  return (
        <rootContext.Provider value={{
          isScreenTooSmall: isScreenTooSmall,
          isScreenWayTooSmall: isScreenWayTooSmall
        }}>
          <RouterProvider router={router} />
        </rootContext.Provider>
    );
}

export default App;
